import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { Select } from 'antd';
import FullscreenOutlined from '@ant-design/icons';

export const Button = styled.button`
  color: ${(props) => props.theme.fg};
  border: 2px solid ${(props) => props.theme.fg};
  background: ${(props) => props.theme.bg};
  margin: 1em;
  padding: 0.25em 1em;
  border-radius: 3px;
`;
export const FullScreenIcon = styled(FullscreenOutlined)`
  float: right;
  color: ${(props) => props.theme.fg};
  margin-right: 10px;
  margin-top: -30px;
  cursor: pointer;
  
`;
export const DashboardDiv = styled.div`
  // margin-top: -3px;
  // min-height: 93.5vh;
`;
export const Title = styled.h3`
  color: ${(props) => props.theme.fg};
  background: ${(props) => props.theme.hg};
  text-align: center;
  border-radius: 10px 10px 0px 0px;
  -moz-border-radius: 10px 10px 0px 0px;
  -webkit-border-radius: 10px 10px 0px 0px;
  padding: 0.7em 0em;
  margin: 0px;
`;
export const PanelDiv = styled.div`
  background-color: ${(props) => props.theme.hg} !important;
  box-shadow: 3px 3px 7px ${(props) => props.theme.shadow};
  -moz-box-shadow: 0px 2px 7px ${(props) => props.theme.shadow};
  -webkit-box-shadow: 0px 2px 7px ${(props) => props.theme.shadow};
  border-radius: 10px;
  -moz-border-radius: 10px;
  -webkit-border-radius: 10px;
`;

export const DashboardHeaderDiv = styled.div`
  height: 40px;
  display: flex;
  justify-content: flex-end;
  flex-flow: row wrap;
`;

export const ModalDiv = styled.div`
  background-color: ${(props) => props.theme.hg};

  border-radius: 10px;
  -moz-border-radius: 10px;
  -webkit-border-radius: 10px;
`;
export const DateRangePickerDiv = styled.div`
  margin-left: -20%;
  display: ${(props) => (props.showDateRange === false ? 'none' : 'block')};
`;

export const NoPanelmessage = styled.div`
  text-align: center;
  color: white;
  margin-top: 25%;
  
`;

export const StyledIFrame = styled.iframe`
  width: 402%;
  height: 400%;
  border: 0;
  position: absolute;
  top: 0;
  left: -0.5%;
  background: #191a1d;
  -webkit-transform: scale(0.5);
  transform: scale(0.25);
  -webkit-transform-origin: top left;
  transform-origin: top left;
  -webkit-transition: opacity 0.4s ease;
  transition: opacity 0.4s ease;
  margin: 2px auto;
`;

export const LinkOverlay = styled(Link)`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1;
  :hover {
    cursor: pointer;
    background: rgba(255, 255, 255, 0.3);
  }
`;

export const SelectDropDown = styled(Select)`
  width: 100%;
`;
export const CommonDiv = styled.div`
  margin-top: 5px;
`;

export const DateSelection = styled.div`
  display: flex;
  flex-wrap: nowrap;
  flex-direction: row-reverse;
  padding: 10px;
`;

